import { useLogout, useMe } from "@/hooks/useMe";
import { useNavigate } from "react-router-dom";

/**
 * Settings stub — password change, email notification preferences, account
 * deletion all land here. Wired up after we have email plumbing.
 */
export default function Settings() {
  const me = useMe();
  const logout = useLogout();
  const navigate = useNavigate();

  return (
    <section className="space-y-8">
      <header>
        <h1 className="text-3xl font-semibold">Settings</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Account-level controls — most of this is stub for v1.
        </p>
      </header>

      <div className="space-y-4 rounded-lg border p-6">
        <h2 className="text-lg font-semibold">Account</h2>
        <Row label="Email" value={me.data?.email ?? "—"} />
        <Row
          label="Password"
          value="••••••••"
          action={<ComingSoonPill>Change password</ComingSoonPill>}
        />
        <Row
          label="Notifications"
          value="Email reminders for compliance deadlines (off)"
          action={<ComingSoonPill>Configure</ComingSoonPill>}
        />
      </div>

      <div className="space-y-3 rounded-lg border border-destructive/30 p-6">
        <h2 className="text-lg font-semibold">Danger zone</h2>
        <p className="text-sm text-muted-foreground">
          Logging out clears your session on this device. Account deletion is
          on the roadmap once we have a proper request/confirmation flow.
        </p>
        <button
          type="button"
          onClick={() => {
            logout();
            navigate("/dashboard");
          }}
          className="rounded-md border px-3 py-2 text-sm font-medium hover:bg-secondary"
        >
          Log out
        </button>
      </div>
    </section>
  );
}

function Row({
  label,
  value,
  action,
}: {
  label: string;
  value: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="flex items-center justify-between gap-3 border-t pt-3 first:border-t-0 first:pt-0">
      <div>
        <div className="text-xs uppercase tracking-wide text-muted-foreground">
          {label}
        </div>
        <div className="mt-0.5 text-sm">{value}</div>
      </div>
      {action}
    </div>
  );
}

function ComingSoonPill({ children }: { children: React.ReactNode }) {
  return (
    <span className="rounded-full border px-2.5 py-1 text-xs text-muted-foreground">
      {children}
    </span>
  );
}
